export default __webpack_public_path__ + "static/media/single-project-page-05-img-15.c17bb942.jpg";